import { get, useFormContext } from "react-hook-form";

import FormField from "ds/components/Form/Field";
import Input from "ds/components/Input";
import { validateUnixVariableName } from "utils/formValidators";

type ContextConfigFormNameFieldProps = {
  name: string;
  existingNames?: string[];
};

const ContextConfigFormNameField = ({ name, existingNames }: ContextConfigFormNameFieldProps) => {
  const { register, formState } = useFormContext();
  const error = get(formState.errors, name);

  return (
    <FormField label="Name" noMargin fullWidth error={error?.message}>
      {({ ariaInputProps }) => (
        <Input
          placeholder="Enter variable name here..."
          error={!!error}
          {...register(name, {
            required: "Name field is required.",
            validate: validateUnixVariableName(existingNames),
          })}
          {...ariaInputProps}
        />
      )}
    </FormField>
  );
};

export default ContextConfigFormNameField;
